const roles = {
  role_super_admin: 'ROLE_SUPER_ADMIN',
  role_admin: 'ROLE_ADMIN',
  role_risk_sector: 'ROLE_RISK_SECTOR',
  role_user_in_charge: 'ROLE_USER_IN_CHARGE',
  role_responsible_user: 'ROLE_RESPONSIBLE_USER',
  role_technological: 'ROLE_TECHNOLOGICAL',

  role_sector_director:"ROLE_SECTOR_DIRECTOR",
  role_internal_auditor:"ROLE_INTERNAL_AUDITOR",
  role_internal_audit_responsible: "ROLE_AUDIT_RESPONSIBLE_USER",
  role_head_of_internal_audit:"ROLE_HEAD_OF_INTERNAL_AUDIT",

  //roles for externalization
  role_user_in_charge_for_externalization: "ROLE_USER_IN_CHARGE_FOR_EXTERNALIZATION",
  role_user_responsible_for_externalization: "ROLE_USER_RESPONSIBLE_FOR_EXTERNALIZATION"
};

export default roles;
